<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" label-width="auto" label-position="right">
      <el-form-item label="平日营业时间：">
        <el-button @click="editTime(1, -1)">添加平日营业时间</el-button>
        <div class="time-box" v-if="ordinaryHour.length > 0" style="margin-top: 12px">
          <div v-for="(item, index) in ordinaryHour" :key="item.id"  class="time-list">
            <div class="time-list-item">
              <div class="delBtn" @click="delProject(1, index, item)"><ElIcons name="SemiSelect" color="#ffffff" size="10"/></div>
              <span>{{item.startNum == 1?'周一':item.startNum == 2?'周二':item.startNum == 3?'周三':item.startNum == 4?'周四':item.startNum == 5?'周五':item.startNum == 6?'周六':item.startNum == 7?'周日':''}}</span>
              <span>到{{item.endNum == 1?'周一':item.endNum == 2?'周二':item.endNum == 3?'周三':item.endNum == 4?'周四':item.endNum == 5?'周五':item.endNum == 6?'周六':item.endNum == 7?'周日':''}}</span>
              ：
              <span>{{item.startTime}} ~ {{item.endTime}}</span>
            </div>
            <div class="edit-btn" @click="editTime(1, index, item )">编辑</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="节假日营业时间：">
        <div class="time-box" v-if="holidayHour.length > 0">
          <div v-for="(item, index) in holidayHour" :key="item.id"  class="time-list">
            <div class="time-list-item">
              <div class="delBtn" @click="delProject(2, index, item)"><ElIcons name="SemiSelect" color="#ffffff" size="10"/></div>
              <span>节假日</span>
              ：
              <span>{{item.startTime}} ~ {{item.endTime}}</span>
            </div>
            <div class="edit-btn" @click="editTime(2, index, item)">编辑</div>
          </div>
        </div>
        <el-button v-else @click="editTime(2, -1)">添加节假日营业时间</el-button>
      </el-form-item>
    </el-form>
<!--    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">-->
<!--      <el-button @click.native="cancel" >取消</el-button>-->
<!--      <el-button type="primary" @click="summit">确定</el-button>-->
<!--    </div>-->
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import {delBusinessHours, delPetBreedColor} from "@/api/url";
import Dialog from "@/assets/js/dialog";
import shopTimeEditDialog from "@/views/shop/components/shopTimeEditDialog";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      businessForm: this.value.businessForm,
      businessHoursList: this.value.businessForm.businessHoursList?this.value.businessForm.businessHoursList:[],
      holidayHour: [],
      ordinaryHour: [],
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },

    editTime(type, idx, row) {
      let _title = '';
      let timeForm = {}
      if(type == 1) {
        _title = '平日营业时间'
      }else {
        _title = '节假日营业时间'
      }
      if (idx > -1) {
        timeForm = Object.assign({}, row);
      }
      Dialog.open({
        title: _title,
        component: shopTimeEditDialog,
        data: {
          timeForm: timeForm,
          shopId: this.businessForm.id,
          ids: idx,
          type: type,
          width: '500px',
        },
        confirm: (result) => {
          if(type == 1) {
            if(idx > -1) {
              this.ordinaryHour[idx].startNum = result.startNum
              this.ordinaryHour[idx].endNum = result.endNum
              this.ordinaryHour[idx].startTime = result.startTime
              this.ordinaryHour[idx].endTime = result.endTime
            }else {
              this.$emit('confirm')
            }
          }else {
            if(idx > -1) {
              this.holidayHour[idx].startNum = result.startNum
              this.holidayHour[idx].endNum = result.endNum
              this.holidayHour[idx].startTime = result.startTime
              this.holidayHour[idx].endTime = result.endTime
            }else {
              this.$emit('confirm')
            }

          }
        }
      })
    },

    delProject(type, idx, row) {
      this.$confirm('确定删除'+ (type == 1?'平日营业时间':'节假日营业时间')).then(()=> {
        let param = {}
        param['id'] = row.id;
        postFormData(delBusinessHours, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            if(type == 1) {
              this.ordinaryHour.splice(idx, 1)
            }else {
              this.holidayHour.splice(idx, 1)
            }
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      })
    }


  },
  mounted() {
    this.holidayHour = this.businessHoursList.filter(item => item.startNum == 8)
    this.ordinaryHour = this.businessHoursList.filter(item => item.startNum < 8)
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
.delBtn {
  background-color: #bbbbbb;
  color: #ffffff;
  height: 18px;
  width: 18px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 10px;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 12px;
}
.delBtn:hover {
  background-color: red;
}
.time-box {
  width: 100%;
  /*display: flex;*/
  /*align-items: center;*/
  padding: 8px 16px;
  background-color: #f6f6f6;
  border-radius: 8px;
}
.time-box span {
  white-space: nowrap;
}

.time-list {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.time-list-item {
  display: flex;
  align-items: center;
}
.edit-btn {
  color: #3a8ee6;
  cursor: pointer;
}
</style>
